import { render, staticRenderFns } from "./child-item.vue?vue&type=template&id=d90563f2"
import script from "./child-item.vue?vue&type=script&lang=js"
export * from "./child-item.vue?vue&type=script&lang=js"
import style0 from "./child-item.vue?vue&type=style&index=0&id=d90563f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports